import {
  getData,
  postData,
  convertPageModel
} from './api-base.service'
import {
  getCourseTypeText
} from "@/config/mUtils";

export const createWorkflowModel = (enrollmentType) => {
  if (typeof enrollmentType == "undefined") {
    enrollmentType = 1;
  }
  return {
    Id: 0,
    Enable: true,
    StudentId: 0,
    SelectedAdvanceEnrollmentId: 0,
    AdvanceEnrollmentCount: 0,
    AdvanceEnrollmentPrice: 0,
    AdvanceEnrollmentPriceTax: 0,
    BuyMemberCardPrice: 0,
    MemberCardPrice: 0,
    CourseType: 1,
    MemberCardNumber: null,
    ContractId: null,
    BalanceCost: 0,
    BonusPointCost: 0,
    BonusPointAmount: 0,
    PaymentCommissionCost: 0,
    CurrentStep: 0,
    IsCompleted: false,
    AccountId: null,
    ReceiptFileId: null,
    Phone: null,
    OriginalPaymentCommissionCost: 0,
    TotalAmount: 0,
    EnrollmentType: enrollmentType,
    CashDecreasedAmount: 0,
    WorkflowDiscounts: [],
    WorkflowCourses: [],
    HasTaxSetting: true,
    HasTax: true,
    CourseTotalTax: 0,
    BalanceCostTax: 0,
    TaxRate: 0,
    IsAutonomousEnrolment: false,
    IsAutonomousPayment: false,
    Status: 0,
    PaymentType: null,
    CouponCode: "",
    CouponDiscountValue: null
  };
}

export const getCourseListData = (workflowData, memberModel, studentAdvanceEnrollmentList) => {
  let list = [];
  if (!!workflowData.WorkflowCourses && workflowData.WorkflowCourses.length > 0) {
    workflowData.WorkflowCourses.forEach(element => {
      let discountPrice = element.DiscountPrice;
      if (element.DiscountPriceBeforeCoupon) {
        discountPrice = element.DiscountPriceBeforeCoupon;
      }

      let itemData = {
        modelData: {
          isAdvanceEnrollmentPrice: element.IsAdvanceEnrollmentPrice,
          isInternalPrice: element.IsInternalPrice,
          isOriginalPrice: element.IsOriginalPrice,
          isFreeTrial: element.IsFreeTrial,
          isVideoFree: element.IsVideoFree,
          isAiCourseEnabled: element.IsAiCourseEnabled,
          isEnsureACourse: element.IsEnsureACourse,
          startWeek: element.StartWeek,
          categoryId: element.CourseCategoryId,
          categoryOptionId: element.CourseCategoryOptionId,
          vipCoursePriceId: element.VipCoursePriceId,
          courseCount: element.CourseCount,
          courseMinutes: element.CourseMinutes,
          supplementVideoType: element.SupplementVideoType,
          supplementVideoCount: element.SupplementVideoCount,
          contractId: element.ContractId,
          weChatGroupType: element.WeChatGroupType,
          comment: element.Comment,
          selectedStudentAdvanceEnrollmentId: element.SelectedStudentAdvanceEnrollmentId,
          yearCourseType: element.YearCourseType,
          courseActivationIdList: element.CourseActivationIdList,
          freeTrialCourseActivationId: element.FreeTrialCourseActivationId,
          courseAlias: element.CourseAlias,
          reviewCourseStart: element.ReviewCourseStartValue,
          reviewCourseEnd: element.ReviewCourseEndValue,
        },
        priceData: {
          price: element.Price,
          discountPrice: discountPrice,
          couponDiscountPrice: element.DiscountPrice,
          subtotal: element.PaymentDiscountPrice,
          supplementVideoPrice: element.SupplementVideoPrice,
          changeCourseDifferentPrice: element.ChangeCourseDifferentPrice,
          changeCourseRefundPrice: element.ChangeCourseRefundPrice,
          changeCourseRefundBalance: element.ChangeCourseRefundBalance,
          bonusPointCost: element.BonusPointCost,
          bonusPointAmount: element.BonusPointAmount,
          cashDecreasedAmount: element.CashDecreasedAmount,
          oldBonusPointCost: element.BonusPointCost,
          couponCode: element.CouponCode,
          couponDiscountDollar: element.CouponDiscountDollar,
        },
        courseId: element.CourseId,
        courseName: element.CourseName,
        courseType: element.CourseType,
        courseTypeText: getCourseTypeText(
          element.CourseType
        ),
        universityGroup: memberModel.UniversityGroupNumber,
        universityGroupText: memberModel.UniversityGroupText,
        termId: workflowData.TermId,
        termText: workflowData.TermText,
        categoryId: workflowData.CategoryId,
        categoryText: workflowData.CategoryText,
        campusId: element.CampusId,
        campusText: element.CampusText,
        isRefund: element.IsRefund,
        isHourPrice: false,
        isYearCourse: element.IsYearCourse,
        yearCourseType: element.YearCourseType,
        defaultContractId: element.DefaultContractId,
      };

      if (element.CourseType == 2) {
        itemData.isHourPrice = element.IsHourPrice;
      }

      list.push(itemData);
    });
  }

  let enrollmentCount = 0;
  let trainingEnrollmentCount = 0;
  if (!!memberModel) {
    enrollmentCount = studentAdvanceEnrollmentList.length;
    trainingEnrollmentCount =
      memberModel.TrainingAdvanceEnrollmentCount -
      memberModel.TrainingAdvanceEnrollmentCountUsed;
  }

  let courseListData = {
    termId: workflowData.TermId,
    categoryId: workflowData.CategoryId,
    comment: workflowData.Comment,
    enrollmentAvailableCount: enrollmentCount,
    trainingEnrollmentAvailableCount: trainingEnrollmentCount,
    courseList: list,
    studentAdvanceEnrollmentList: studentAdvanceEnrollmentList,
    studentAdvanceEnrollmentAdditional: workflowData.StudentAdvanceEnrollmentAdditional,
  };
  return courseListData;
}

export const getDiscountArrayFromWorkflowDiscounts = (discountModels) => {
  let discounts = [];
  for (let i = 0; i < discountModels.length; i++) {
    discounts.push(discountModels[i].FormulaFieldId);
  }
  return discounts;
}

export const getDiscountArrayFromWorkflow = (workflow) => {
  let discounts = getDiscountArrayFromWorkflowDiscounts(workflow.WorkflowDiscounts);

  return discounts;
}

export const setWorkflowByDiscountArray = (workflow, discounts) => {
  let newDiscountModel = [];
  for (let i = 0; i < discounts.length; i++) {
    let discountModel = null;
    for (let j = 0; j < workflow.WorkflowDiscounts.length; j++) {
      if (workflow.WorkflowDiscounts[j].FormulaFieldId == discounts[i]) {
        discountModel = workflow.WorkflowDiscounts[j];
        break;
      }
    }
    if (!discountModel) {
      discountModel = {
        Id: 0,
        Enable: true,
        WorkflowId: workflow.Id,
        FormulaFieldId: discounts[i]
      };
    }
    newDiscountModel.push(discountModel);
  }
  workflow.WorkflowDiscounts = newDiscountModel;
}

export const getActiveWorkflowDataByStudentId = (studentId, enrollmentType, isAutonomousEnrolment, workflowId) => {
  if (typeof isAutonomousEnrolment == undefined) {
    isAutonomousEnrolment = false;
  }
  if (typeof workflowId == undefined) {
    workflowId = null;
  }
  let data = {
    studentId: studentId,
    enrollmentType: enrollmentType,
    isAutonomousEnrolment: isAutonomousEnrolment,
    workflowId: workflowId
  };
  let fetchResult = getData('/EnrollmentFee/GetActiveWorkflowDataByStudentId', data);

  return fetchResult;
}

export const getWorkflowDataByAccountId = (accountId) => {
  let data = {
    accountId: accountId
  };
  let fetchResult = getData('/EnrollmentFee/GetWorkflowDataByAccountId', data);

  return fetchResult;
}

export const saveWorkflowData = (model) => {
  let data = model;
  let fetchResult = postData('/EnrollmentFee/SaveWorkflowData', data);

  return fetchResult;
}

export const getAccountByWorkflowId = (studentId, workflowId) => {
  let data = {
    studentId: studentId,
    workflowId: workflowId
  };
  let fetchResult = getData('/EnrollmentFee/GetAccountByWorkflowId', data);

  return fetchResult;
}

export const createCalculateWorkflowResultModel = () => {
  return [];
}

export const calculateAdvanceEnrollment = (studentId, formulaList, replacedValues, courseType) => {
  let data = {
    StudentId: studentId,
    FormulaList: formulaList,
    ReplacedValues: replacedValues,
    CourseType: courseType
  }
  let fetchResult = postData('/EnrollmentFee/CalculateAdvanceEnrollment', data);

  return fetchResult;
}

export const calculateEnrollmentFee = (model) => {
  let data = model;
  if (data.selectedAdvanceEnrollmentId == "") {
    data.selectedAdvanceEnrollmentId = 0;
  }
  let fetchResult = postData('/EnrollmentFee/CalculateEnrollmentFee', data, true, true);

  return fetchResult;
}

export const getWorkflowDataById = (workflowId) => {
  let data = {
    workflowId: workflowId
  };
  let result = getData('/EnrollmentFee/GetWorkflowDataById', data);
  return result;
}

export const getContinuPaymentViewModel = (workflowId, studentId) => {
  let data = {
    workflowId: workflowId,
    studentId: studentId
  };
  let result = getData('/EnrollmentFee/GetContinuePaymentViewModel', data);
  return result;
}

export const removeWorkflow = (id) => {
  let data = {
    id: id
  };
  return getData('/EnrollmentFee/RemoveWorkflow', data);
}

export const getEnglishEnsureScore = (id) => {
  let data = {
    id: id
  };
  return getData('/EnrollmentFee/GetEnglishEnsureScore', data);
}

export const saveEnglishEnsureScore = (data) => {
  return postData('/EnrollmentFee/SaveEnglishEnsureScore', data);
}

export const getIncompleteWorkflowList = (model) => {
  let data = convertPageModel(model);
  return postData('/EnrollmentFee/GetIncompleteWorkflowList', data);
}

export const getIncompleteWorkflowCount = () => {
  return getData('/EnrollmentFee/GetIncompleteWorkflowCount');
}

export const getWorkflowCoursesInTerm = (studentId, termId) => {
  let data = {
    studentId: studentId,
    termId: termId
  };
  return getData('/EnrollmentFee/GetWorkflowCoursesInTerm', data);
}

export const changeWeChatGroupType = (id, type) => {
  let data = {
    id: id,
    type: type
  };
  return getData('/EnrollmentFee/ChangeWeChatGroupType', data);
}

export const validateCoupon = (studentId, code, discountType) => {
  let data = {
    studentId: studentId,
    code: code,
    discountType: discountType
  };
  return getData('/EnrollmentFee/ValidateCoupon', data);
}

export const getYearCourseTypeList = (yearCourseTypeAllList, course) => {
  let yearCourseTypeList = [];
  if (course.IsYearCourse && !!course.YearCourseTypeWithWeek) {
    let keys = Object.keys(course.YearCourseTypeWithWeek);
    yearCourseTypeAllList.forEach(i => {
      if (keys.indexOf(i.Value.toString()) >= 0) {
        yearCourseTypeList.push(i);
      }
    });
  }
  return yearCourseTypeList;
}
export const getCourseData = (totalCourseList, yearCourseTypeAllList, courseId, workflowCourse) => {
  let course = totalCourseList.find((i) => i.Id == courseId);
  let yearCourseTypeList = getYearCourseTypeList(yearCourseTypeAllList, course);
  let courseName = course.CourseName;
  if (course.IsYearCourse) {
    courseName = courseName + "(年课)";
  }
  let courseData = {
    CourseId: courseId,
    CourseName: course.CourseName,
    CourseCode: course.CourseCode,
    Price: 0,
    DiscountPrice: 0,
    BonusPointCost: 0,
    BonusPointAmount: 0,
    YearCourseType: 0,
    IsYearCourse: course.IsYearCourse,
    YearCourseTypeList: yearCourseTypeList
  };
  if (!!workflowCourse) {
    courseData.Price = workflowCourse.Price;
    courseData.DiscountPrice = workflowCourse.DiscountPrice;
    courseData.BonusPointCost = workflowCourse.BonusPointCost;
    courseData.BonusPointAmount = workflowCourse.BonusPointAmount;
    courseData.YearCourseType = workflowCourse.YearCourseType;
  } else {
    if (courseData.IsYearCourse && yearCourseTypeList.length > 0) {
      courseData.YearCourseType = yearCourseTypeList[0].Value;
    }
  }

  return courseData;
}

export const getAutonomousPaymentWorkflowList = (model) => {
  let data = convertPageModel(model);
  return postData('/EnrollmentFee/GetAutonomousPaymentWorkflowList', data);
}

export const getFreeTrialCoursePageData = (model) => {
  let data = convertPageModel(model);
  return postData('/EnrollmentFee/GetFreeTrialCoursePageData', data);
}

export const getFreeTrialCourseListForEnroll = (studentId) => {
  let data = {
    studentId
  };
  return getData('/EnrollmentFee/GetFreeTrialCourseListForEnroll', data);
}

export const saveWorkflowStatus = (workflowId, status) => {
  let data = {
    workflowId: workflowId,
    status: status
  };
  return getData('/EnrollmentFee/SaveWorkflowStatus', data);
}

export const getStudentInProgressWorkflowCount = () => {
  return getData('/EnrollmentFee/GetStudentInProgressWorkflowCount');
}

export const refreshEFWorkflowStatus = (workflowId) => {
  let data = {
    workflowId
  };
  return getData('/EnrollmentFee/RefreshEFWorkflowStatus', data);
}

export const agreeEFWCourseContracts = (efwCourseIds) => {
  let data = efwCourseIds;
  return postData('/EnrollmentFee/AgreeEFWCourseContracts', data);
}

export const validateAutonomousPaymentWorkflowCourses = (studentId, workflowId, workflowCourseIdList) => {
  let data = {
    StudentId: studentId,
    WorkflowId: workflowId,
    WorkflowCourseIdList: workflowCourseIdList
  };
  return postData('/EnrollmentFee/ValidateAutonomousPaymentWorkflowCourses', data);
}

export const getStudentLastRefundWorkflowData = (studentId) => {
  let data = {
    studentId
  };
  return getData('/EnrollmentFee/GetStudentLastRefundWorkflowData', data);
}

export const saveAutonomousPaymentRecord = (data) => {
  return postData('/EnrollmentFee/SaveAutonomousPaymentRecord', data);
}

export const getStudentVipCourseRecordPageData = (model) => {
  let data = convertPageModel(model);
  return postData('/EnrollmentFee/GetStudentVipCourseRecordPageData', data);
}

export const getStudentVipCourseRecordSummaryData = (model) => {
  let data = convertPageModel(model);
  return postData('/EnrollmentFee/GetStudentVipCourseRecordSummaryData', data);
}

export const getVipWorkflowCoursesByStudentId = (termId, studentId, id) => {
  let data = {
    termId,
    studentId,
    id
  };
  let result = getData('/EnrollmentFee/GetVipWorkflowCoursesByStudentId', data);
  return result;
}

export const saveStudentVipCourseRecord = (data) => {
  return postData('/EnrollmentFee/SaveStudentVipCourseRecord', data);
}

export const deleteStudentVipCourseRecord = (id) => {
  let data = {
    id
  };
  return getData('/EnrollmentFee/DeleteStudentVipCourseRecord', data);
}

export const getVipCourseAliasList = (keyword, studentId, termId) => {
  let data = {
    keyword,
    studentId,
    termId,
  };
  let result = getData('/EnrollmentFee/GetVipCourseAliasList', data);
  return result;
}

export const updateWorkflowCourseReviewDate = (workflowCourseId, startDate, endDate) => {
  let data ={
    WorkflowCourseId: workflowCourseId,
    StartDate: startDate,
    EndDate: endDate
  }
  return postData('/EnrollmentFee/UpdateWorkflowCourseReviewDate', data);
}


// WEBPACK FOOTER //
// ./src/service/enrollmentFee.service.js